<div class="container-info light animated fadeIn pb-5">

 <div class="p-2 ps-sm-3">
  <h3 class="fw-sbold ps-3 fs-30 pt-3">Selecciona tu domiciliación</h3>
 </div>

  <div class="mt-2">
    <div class="d-block m-auto d-md-flex align-items-md-center justify-content-md-between center-container">
      <div class="col-11 col-md-7 input-select text-center p-3 space cr-pointer"
      [ngClass]="changeInfoPlan ? 'inactivebtn' : 'activebtn'"
      (click)="toggleActive()"
      >
        <h4 class="fw-bold fs-16 m-0">Premium, obtén hasta 300% de bonificación</h4>
      </div>
      <div class="col-11 col-md-5 input-select text-center adjust-s p-3 cr-pointer"
      [ngClass]="!changeInfoPlan ? 'inactivebtn' : 'activebtn'"
      (click)="toggleActive()">
        <h4 class="fw-bold fs-17 m-0">Plan standard</h4>
      </div>
    </div>
  </div>

  <div class="info-plan w-95 p-3 animated fadeIn">
    <div class="d-flex align-items-center pt-3">
      <fa-icon [icon]="iconCheck" [ngStyle]="{'padding-right' : '10px', 'color': '#136176', 'font-size': '25px'}"></fa-icon>
      <p class="m-0 fs-16 c-parrafe">Puedes cancelar cuando quieras</p>
    </div>
    <div class="d-flex mt-3 pb-5">
      <fa-icon [icon]="changeInfoPlan ? iconTimes : iconCheck" [ngStyle]="{'padding-right' : '10px', 'color': changeInfoPlan ? '#FF0000' : '#136176', 'font-size': '25px'}"></fa-icon>
      <p class="m-0 fs-16" [ngClass]="changeInfoPlan ? 'c-block' : 'c-parrafe'">
        Obtén una bonificación de hasta 300%* de en tu primera inversión domiciliada, según el plan que elijas,
        <strong>además de los rendimientos mensuales que generes por invertir.</strong><br><br>
        <a href="https://centrodeayuda.monific.com/t%C3%A9rminos-y-condiciones-de-la-domiciliaci%C3%B3n-en-plan-premium-de-monific" class="text-decoration-underline fw-sbold" [ngClass]="changeInfoPlan ? 'c-block' : 'c-parrafe'"
          rel="noopener noreferrer" target="_blank">Términos y condiciones</a>
      </p>
    </div>
  </div>

  <form [formGroup]="domForm">
    <div class="details-charge d-block m-auto d-md-flex align-items-md-center justify-content-md-around w-95 m-auto">
      <div class="col-10 col-md-5 p-2 m-auto">
        <p class="m-0 fs-15 pb-2 fw-sbold c-parrafe">Frecuencia del cargo automático: </p>
        <mat-form-field appearance="outline" class="mnf-select">
          <mat-select disableRipple formControlName="frecuency">
            <mat-option [value]="s" *ngFor="let s of frecuencyPay" [title]="s.viewValue">
              {{ s.viewValue }}
           </mat-option>
          </mat-select>
       </mat-form-field>
      </div>
      <div class="col-10 col-md-5 p-2 m-auto">
        <p class="m-0 fs-15 pb-2 fw-sbold c-parrafe">CLABE destino: </p>
        <mat-form-field appearance="outline" class="mnf-select">
          <mat-select [value]="'Seleccione'" disableRipple formControlName="clabe">
            <mat-option [value]="s" *ngFor="let s of bankAccounts" [title]="s.alias">
              {{ s.alias }} - {{ s.clabe }}
           </mat-option>
          </mat-select>
       </mat-form-field>
      </div>
    </div>

    <div class="details-charge d-block m-auto d-md-flex align-items-md-center justify-content-md-around w-95 m-auto">
      <div class="col-10 col-md-5 p-2 m-auto">
        <p class="m-0 fs-15 pb-2 fw-sbold c-parrafe">Ingresa el monto a domiciliar: </p>
        <div class="mnf-control mb-0">
          <input class="mnf-input-form" currencyMask autocomplete="off" formControlName="amount">
        </div>
        <div>
          <p class="fs-11">**El monto mínimo es de $500.00</p>
       </div>
      </div>
      <div class="col-10 col-md-5 p-2 m-auto">
        <p class="m-0 fs-15 pb-2 fw-sbold c-parrafe">Selecciona plan: </p>
        <div class="mnf-control">
          <input class="mnf-input-form animated fadeIn cr-pointer" readonly formControlName="plan" (click)="openModalCalculate()" autocomplete="off">
        </div>
      </div>
    </div>
  </form>

  <div class="text-center pb-3 mt-3">
    <button mat-button [disabled]="domForm.invalid" (click)="saveInfo()">Activar mi domiciliación</button>
 </div>

  <div class="info-s w-95 mt-4 m-auto p-3">
    <div class="d-block m-auto text-center d-md-flex align-items-md-center justify-content-md-between">
       <div class="mt-3 mt-md-0">
          <button  class="btn-info default" mat-button [class.selected]="currentParagraph === 1" (click)="showParagraph(1)">¿Cómo funciona?</button>
       </div>
       <div class="mt-3 mt-md-0">
          <button class="btn-info default" mat-button [class.selected]="currentParagraph === 2" (click)="showParagraph(2)">Frecuencia de inversión</button>
       </div>
       <div class="mt-3 mt-md-0">
          <button class="btn-info default" mat-button [class.selected]="currentParagraph === 3" (click)="showParagraph(3)">Cancelaciones</button>
       </div>
    </div>
    <div class="pt-5">
       <div>
          <p class="animated fadeIn fs-15 pt-1" *ngIf="currentParagraph === 1">Una cómoda herramienta que se encarga de invertir por ti, para mantener el crecimiento constante de tu dinero.
             Automatiza tu ahorro de forma segura para alcanzar tus objetivos de inversión. Recuerda que para activar esta opción, es necesario activar tu inversión automática.
             <br><br>
             <a href="https://centrodeayuda.monific.com/c%C3%B3mo-funciona-la-domiciliaci%C3%B3n-en-monific" target="_blank" class="fw-bold cl-black">Leer más.</a>
          </p>
          <p class="animated fadeIn fs-15 pt-1" *ngIf="currentParagraph === 2">
             <strong>Mensual (Primer día</strong> del mes o <strong>día 16</strong> del mes correnspondiente)<br><br>
             <strong>Quincenal (Primer día</strong> del mes y <strong>día 16</strong> del mes correnspondiente)<br><br>

             <strong>**En caso de que el día señalado sea día inhábil, el cargo se realizará el día hábil bancario siguiente.</strong><br><br>

             <a href="https://centrodeayuda.monific.com/bancos-permitidos-para-domiciliaci%C3%B3n" target="_blank" class="fw-bold cl-pink text-decoration-underline">Consulta los bancos disponibles.</a>
          </p>
          <p class="animated fadeIn fs-15 pt-1" *ngIf="currentParagraph === 3">Si deseas cancelar tu domiciliacion, apaga el botón en los ajustes de tu perfil.<br>
             <br>
             <a href="https://centrodeayuda.monific.com/c%C3%B3mo-funciona-la-domiciliaci%C3%B3n-en-monific" target="_blank" class="fw-bold cl-black">Leer más</a>
          </p>
       </div>
    </div>
  </div>

</div>
